/* user/actions */
import { action } from "typesafe-actions";
import {  ResetMfaActionTypes, Data, ResetMfa } from "./types";

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: ResetMfa | null) => unknown
) => action(ResetMfaActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: ResetMfa) =>
  action(ResetMfaActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(ResetMfaActionTypes.SAVE_ERROR, error);
